import { post } from './axios';
import {
  IPostApiAuthorizedRefreshTokenV2Request,
  IPostApiAuthorizedRefreshTokenV2Response,
} from './interface/authorized';

// 刷新 token
export const refreshToken = (
  params: IPostApiAuthorizedRefreshTokenV2Request,
) => {
  return post<
    IPostApiAuthorizedRefreshTokenV2Response,
    IPostApiAuthorizedRefreshTokenV2Response
  >('/api/authorized/refresh_token_V2', params);
};
